var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }